<template>
  <div class="wrap">
    <img src="../../assets/down/down.jpg" class="v-bg-img" />
    <div class="v-down-btn"></div>
  </div>
</template>
<script>
export default {};
</script>
<style lang="scss" scoped>
.wrap {
  position: relative;
  width: 100%;
}
.v-bg-img {
  width: 100%;
}
.v-down-btn {
  width: 56vw;
  height: 9.5vw;
  background: red;
  position: absolute;
  bottom: 62vw;
  left: 22vw;
}
</style>
